export interface UserLogin {
  id: number;
  user_id: number;
  first_name: string;
  last_name: string;
  email: string;
  logged_in_at: string;
  ip_address?: string;
  user_agent?: string;
}

export interface UserLoginsResponse {
  logins: UserLogin[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
  timestamp: string;
}

export interface UserLoginsParams {
  userId?: number;
  limit?: number;
  offset?: number;
  sortBy?: 'user_id' | 'logged_in_at' | 'first_name' | 'last_name' | 'email';
  sortOrder?: 'asc' | 'desc';
}

export async function fetchUserLogins(params: UserLoginsParams = {}): Promise<UserLoginsResponse> {
  const token = localStorage.getItem('authToken');
  const searchParams = new URLSearchParams();
  
  if (params.userId) searchParams.append('userId', params.userId.toString());
  if (params.limit) searchParams.append('limit', params.limit.toString());
  if (params.offset) searchParams.append('offset', params.offset.toString());
  if (params.sortBy) searchParams.append('sortBy', params.sortBy);
  if (params.sortOrder) searchParams.append('sortOrder', params.sortOrder);
  
  const response = await fetch(`/api/user-logins?${searchParams}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  
  if (!response.ok) {
    throw new Error(`Failed to fetch user logins: ${response.status} ${response.statusText}`);
  }
  
  return response.json();
}
